/* global google */
// **************************************************
// Filter
// **************************************************

const filterOptions = document.querySelectorAll('.sc-filter-infos .filter__option');
const filterReset = document.querySelector('.filter__redo');
const allGmapPins = document.querySelectorAll('.map__pins-info');

const allPins = [...allGmapPins].map((gmapPin) => {
  return {
    markerAttr: gmapPin.getAttribute('data-marker'),
    latAttr: gmapPin.getAttribute('data-markerlat'),
    lngAttr: gmapPin.getAttribute('data-markerlng'),
  }
});

function getData(element) {
  return  {
    mapLat: element.getAttribute('data-lat'),
    mapLng: element.getAttribute('data-lng'),
    mapZoom: element.getAttribute('data-zoom'),
  }
}

// Remove all filters
function removeFilters() {
  filterOptions.forEach((filterOption) => {
    filterOption.classList.remove('is-active');
    const allUnits = document.querySelectorAll('.contact-card__wrapper');

    allUnits.forEach((unit) => {
      unit.classList.remove('is-hidden');
    });

    allGmapPins.forEach((gmapPin, index) => {
      const { markerAttr, latAttr, lngAttr } = allPins[index];
      gmapPin.setAttribute('data-marker', markerAttr);
      gmapPin.setAttribute('data-markerlat', latAttr);
      gmapPin.setAttribute('data-markerlng', lngAttr);
    });

    const { mapLat, mapLng, mapZoom } = getData(gMap);
    initialize(gMap, mapLat, mapLng, mapZoom);
  });
}

filterOptions.forEach((filterOption) => {
  const filterName = filterOption.getAttribute('data-info-filter');
  const units = document.querySelectorAll(`.contact-card__wrapper:not(.${filterName})`);
  const otherGmapPins = document.querySelectorAll(`.map__pins-info:not(.${filterName})`);

  filterOption.addEventListener('click', () => {
    removeFilters();

    filterOption.classList.add('is-active');
    filterReset.removeAttribute('hidden');

    units.forEach((unit) => {
      unit.classList.add('is-hidden');
    });

    otherGmapPins.forEach((pin) => {
      pin.removeAttribute('data-marker');
      pin.removeAttribute('data-markerlat');
      pin.removeAttribute('data-markerlng');
    });

    const { mapLat, mapLng, mapZoom } = getData(gMap);
    initialize(gMap, mapLat, mapLng, mapZoom);
  });
});

filterReset?.addEventListener('click', () => {
  removeFilters();
  filterReset.setAttribute('hidden', '');
});
